import React, { FC, useEffect, useState } from 'react'
import styles from './aea-breadcrumb.module.scss';
import { Breadcrumb, Row, BreadcrumbItem } from 'reactstrap';
import { INavigation } from '@interfaces/ux/navigation.interface';
import { NavigationPresenter } from '@presenters/ux/navigation.presenter';

const AEABreadcrumb: FC = () => {
    const [routes, setRoutes] = useState([]);
    const view: INavigation = {
      state:{
          routes,
          setRoutes
      }  
    };
    const presenter = new NavigationPresenter(view);
    useEffect(() => {
        presenter.getRoutes();
    },[]);

    return (
        <h4 className={styles.PageTitle + " mb-5 mt-2 pl-3"}>
        <Row>
            <Breadcrumb tag="nav" listTag="div">
                <BreadcrumbItem> 
                    <a 
                        className={styles.BackTitle}
                        onClick={presenter.goBack}
                        >
                            {presenter.backTitle}
                    </a>
                </BreadcrumbItem>
                <BreadcrumbItem> {presenter.title} </BreadcrumbItem>
            </Breadcrumb>
            <div className={styles.SubTitle}>
                {presenter.subTitle} 
            </div>  
        </Row>
      
    </h4>
    )
}

export default AEABreadcrumb;
